import { memo } from "react";

/**
 * DynamicBackground — the site sits on a clean, flat white canvas
 * (Apple-style). Kept as a component so Layout's structure is unchanged.
 */
function DynamicBackgroundInner() {
  return <div aria-hidden="true" className="fixed inset-0 -z-10 pointer-events-none bg-background" />;
}

export const DynamicBackground = memo(DynamicBackgroundInner);
